export class UnitOfMeasureDTO {
  unitOfMeasureId: string;
  unitOfMeasureCode: string;
  unitOfMeasureDescription: string;
  isActive: boolean;
  modifiedBy: string | null;
  modifiedDate: string | null;
}
